import React from 'react';
import { string } from 'prop-types';
import './styles.less';

/**
 * Topic videos are YouTube-hosted, and the previous implementation reached for
 * a full web-component player library to render what is ultimately YouTube's
 * own iframe. The iframe is the thing that actually plays the video, so it is
 * used directly; `youtube-nocookie.com` keeps the embed from setting tracking
 * cookies for students.
 */
const Player = ({ videoId }) => (
  <div className="icsa-player">
    <iframe
      src={`https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}`}
      title="Topic video"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      loading="lazy"
    />
  </div>
);

Player.propTypes = {
  videoId: string.isRequired,
};

export default Player;
